module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-dizzy.44acde1e.svg";